
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 88"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{staticClass:"icon-stroke",attrs:{"x":"1","y":"1","width":"30","height":"51.41","rx":"15","fill":"none","stroke":"#e95314","stroke-miterlimit":"10","stroke-width":"2"}}),_c('rect',{staticClass:"icon-fill mouse-wheel",attrs:{"x":"13.08","y":"9.44","width":"5.84","height":"13.09","rx":"2.92","fill":"#e95314"}}),_c('path',{staticClass:"icon-stroke scroll-caret",attrs:{"fill":"none","stroke":"#e95314","stroke-miterlimit":"10","stroke-width":"2","d":"M24.5 67.97l-8.5 8.5-8.5-8.5"}})])
          )
        }
      }
    